// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IAppNotificationDto,
  ICommunicationDto,
  IDismissedAppNotificationDto,
  IDismissedSearchDto,
  IEmailTemplateThemeDto,
  IErrorDto,
  IExternalTemplateLiteDto,
  IGenericErrorDto,
  IPageExternalTemplateLiteDto,
  IPageable,
} from '../models/index';
import {
    IAppNotificationDtoFromJSON,
    IAppNotificationDtoToJSON,
    ICommunicationDtoFromJSON,
    ICommunicationDtoToJSON,
    IDismissedAppNotificationDtoFromJSON,
    IDismissedAppNotificationDtoToJSON,
    IDismissedSearchDtoFromJSON,
    IDismissedSearchDtoToJSON,
    IEmailTemplateThemeDtoFromJSON,
    IEmailTemplateThemeDtoToJSON,
    IErrorDtoFromJSON,
    IErrorDtoToJSON,
    IExternalTemplateLiteDtoFromJSON,
    IExternalTemplateLiteDtoToJSON,
    IGenericErrorDtoFromJSON,
    IGenericErrorDtoToJSON,
    IPageExternalTemplateLiteDtoFromJSON,
    IPageExternalTemplateLiteDtoToJSON,
    IPageableFromJSON,
    IPageableToJSON,
} from '../models/index';

export interface DismissAppNotificationByIdRequest {
    correspondenceId: number;
}

export interface DismissBannerRequest {
    bannerKey: string;
}

export interface GetAllDismissedAppNotificationsRequest {
    searchDto: IDismissedSearchDto;
    pageable: IPageable;
}

export interface GetCommunicationsRequest {
    employeeId: number;
    search?: string;
    communicationTypes?: Array<GetCommunicationsCommunicationTypesEnum>;
    notificationStatuses?: Array<GetCommunicationsNotificationStatusesEnum>;
    startDate?: string;
    endDate?: string;
}

export interface GetEmailTemplatePreviewRequest {
    id: number;
}

export interface GetEmailTemplateThemesRequest {
    organizationPath: string;
}

export interface GetExternalTemplatesByIdsRequest {
    templateIds: Set<number>;
    name?: string;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetExternalTemplatesByOrgPathRequest {
    userType: GetExternalTemplatesByOrgPathUserTypeEnum;
    notificationType: GetExternalTemplatesByOrgPathNotificationTypeEnum;
}

export interface GetSmsTemplatePreviewRequest {
    id: number;
}

export interface ResendCommunicationRequest {
    id: number;
}

/**
 * NotificationServiceServiceApi - interface
 * 
 * @export
 * @interface NotificationServiceServiceApiInterface
 */
export interface NotificationServiceServiceApiInterface {
    /**
     * 
     * @summary Dismiss notifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationServiceServiceApiInterface
     */
    dismissAllAppNotificationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Dismiss notifications
     */
    dismissAllAppNotifications(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Dismiss notifications
     * @param {number} correspondenceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationServiceServiceApiInterface
     */
    dismissAppNotificationByIdRaw(requestParameters: DismissAppNotificationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Dismiss notifications
     */
    dismissAppNotificationById(requestParameters: DismissAppNotificationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Dismiss a banner for authenticated participant user
     * @param {string} bannerKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationServiceServiceApiInterface
     */
    dismissBannerRaw(requestParameters: DismissBannerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Dismiss a banner for authenticated participant user
     */
    dismissBanner(requestParameters: DismissBannerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get dismissed notifications
     * @param {IDismissedSearchDto} searchDto 
     * @param {IPageable} pageable 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationServiceServiceApiInterface
     */
    getAllDismissedAppNotificationsRaw(requestParameters: GetAllDismissedAppNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDismissedAppNotificationDto>>;

    /**
     * Get dismissed notifications
     */
    getAllDismissedAppNotifications(requestParameters: GetAllDismissedAppNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDismissedAppNotificationDto>;

    /**
     * 
     * @summary Get application notifications for given employee
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationServiceServiceApiInterface
     */
    getAppNotificationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IAppNotificationDto>>>;

    /**
     * Get application notifications for given employee
     */
    getAppNotifications(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IAppNotificationDto>>;

    /**
     * 
     * @summary Get stream of application notifications for given employee
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationServiceServiceApiInterface
     */
    getAppNotificationsStreamRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IAppNotificationDto>>>;

    /**
     * Get stream of application notifications for given employee
     */
    getAppNotificationsStream(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IAppNotificationDto>>;

    /**
     * 
     * @param {number} employeeId 
     * @param {string} [search] 
     * @param {Array<'EMAIL' | 'LETTER' | 'SMS'>} [communicationTypes] 
     * @param {Array<'NOT_SENT' | 'SENT' | 'CANCELLED' | 'ARCHIVED' | 'READ' | 'RESENT' | 'SENDING' | 'BOUNCED' | 'DELIVERED' | 'OPENED' | 'REPORTED_AS_SPAM' | 'UNSUBSCRIBED' | 'RETURNED' | 'PENDING_ADDRESS'>} [notificationStatuses] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationServiceServiceApiInterface
     */
    getCommunicationsRaw(requestParameters: GetCommunicationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICommunicationDto>>;

    /**
     */
    getCommunications(requestParameters: GetCommunicationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICommunicationDto>;

    /**
     * 
     * @summary Get dismissed banner keys for authenticated participant user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationServiceServiceApiInterface
     */
    getDismissedBannersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>>;

    /**
     * Get dismissed banner keys for authenticated participant user
     */
    getDismissedBanners(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>>;

    /**
     * 
     * @summary Get email preview from SendGrid
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationServiceServiceApiInterface
     */
    getEmailTemplatePreviewRaw(requestParameters: GetEmailTemplatePreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Get email preview from SendGrid
     */
    getEmailTemplatePreview(requestParameters: GetEmailTemplatePreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get email template themes for given organization path
     * @param {string} organizationPath 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationServiceServiceApiInterface
     */
    getEmailTemplateThemesRaw(requestParameters: GetEmailTemplateThemesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEmailTemplateThemeDto>>>;

    /**
     * Get email template themes for given organization path
     */
    getEmailTemplateThemes(requestParameters: GetEmailTemplateThemesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEmailTemplateThemeDto>>;

    /**
     * 
     * @summary Get external templates by ids
     * @param {Set<number>} templateIds 
     * @param {string} [name] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationServiceServiceApiInterface
     */
    getExternalTemplatesByIdsRaw(requestParameters: GetExternalTemplatesByIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageExternalTemplateLiteDto>>;

    /**
     * Get external templates by ids
     */
    getExternalTemplatesByIds(requestParameters: GetExternalTemplatesByIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageExternalTemplateLiteDto>;

    /**
     * 
     * @summary Get external templates by type, userRole and org path
     * @param {'PARTICIPANT' | 'ADMIN'} userType 
     * @param {'SIGN_UP' | 'FORGOT_PASSWORD' | 'WELCOME_ABOARD' | 'BENEFICIARY_CHANGES' | 'TRANSFER_OF_ASSETS_UPDATES' | 'CARD_STATUS_CHANGE' | 'PROFILE_UPDATE' | 'PAYMENT_METHOD_UPDATE' | 'CLAIM_ACTIVITY_ACTION' | 'CARD_TRANSACTION_ALERT' | 'PASSWORD_CHANGED' | 'CLAIM_ACTIVITY_NO_ACTION' | 'CONTRIBUTION_INVOICE_READY' | 'REPLENISHMENT_INVOICE_READY' | 'CARD_ACTIVATION_REMINDER' | 'TRIGGER_MET' | 'ORPHAN' | 'CLOSED_ACCOUNT' | 'ACH_REJECTED' | 'PRE_FUND' | 'INDIVIDUAL_CONTRIBUTION' | 'FILE_PROCESSED_SUCCESSFULLY' | 'STATEMENT_GENERATED' | 'CIP_FAILED' | 'INDIVIDUAL_CONTRIBUTION_REMINDER' | 'CARD_DECLINE_ACTIVATION_NEEDED' | 'OUTSTANDING_CHECK_REMINDER' | 'CARD_DECLINE_LOST_STOLEN' | 'CARD_DECLINE_LOCKED_FROZEN' | 'CHECK_VOID' | 'AUTOMATIC_INVESTMENTS' | 'CARD_DECLINE_WALMART' | 'CARD_DECLINE_NON_HEALTHCARE' | 'REIMBURSEMENT_FAILED' | 'CARD_DECLINE_CVS_NOT_ALLOWED' | 'CARD_DECLINE_NOT_ENOUGH_BALANCE' | 'CARD_DECLINE_PLAN_NOT_STARTED' | 'CHECK_EXPIRED' | 'CARD_DECLINE_NO_AVAILABLE_BALANCE' | 'CARD_DECLINE_GENERIC' | 'INDIVIDUAL_CONTRIBUTION_FAILED' | 'CARD_DECLINE_PAST_PLAN_END_DATE' | 'ISO_NEEDS_HELP' | 'CARD_DECLINE_PIN_INVALID' | 'ISO_ORG_LOCKED' | 'ISO_OVERLIMIT' | 'PHONE_VERIFICATION' | 'MFA_SMS' | 'MFA_EMAIL' | 'CARD_DECLINE_NOT_ALLOWED_SERVICE_FOR_PLAN' | 'EMAIL_VERIFICATION' | 'FORGOT_USERNAME' | 'CARD_DECLINE_PEND_CONTRIBUTIONS' | 'CARD_DECLINE_PEND_CONTRIBUTIONS_AND_CIP' | 'COMPLETE_SETUP' | 'EMPLOYEE_ELECTION_NEEDED' | 'END_PLAN_YEAR_INITIAL' | 'LOCKBOX_INBOUND_TOA_PROCESSED' | 'CONTACT_INFO_UPDATED' | 'SCHEDULED_CONTRIBUTION' | 'END_PLAN_YEAR_REMINDER' | 'CLAIM_OFFSET' | 'LOCKBOX_OUTBOUND_TOA_PENDING_INVESTMENTS' | 'LOCKBOX_OUTBOUND_TOA_PROCESSED' | 'NEW_BANK_ACCOUNT_ADDED' | 'SMS_CONTACT_VERIFICATION' | 'EMAIL_CONTACT_VERIFICATION' | 'BANK_ACCOUNT_VERIFICATION_STATUS_CHANGE' | 'PERSON_ACCOUNTS_LINKED' | 'TAX_FORMS' | 'PRE_FUND_PUSH' | 'CARD_DECLINE_DATA_ENTERED_INCORRECTLY' | 'DUPLICATE_FILE_FOUND' | 'INTERNAL_FEEDBACK' | 'BENEFICIARY_UPDATE' | 'RENEWAL_INITIAL' | 'CIP_FAILED_CLOSED_ACCOUNT' | 'CARD_DECLINE_TEMPORARY_BLOCKED_MERCHANT' | 'CARD_DECLINE_PERMANENTLY_BLOCKED_MERCHANT' | 'RENEWAL_REQUEST' | 'CARD_DECLINE_TERMINATED_EMPLOYEE' | 'CARD_DECLINE_TERMINATED_EMPLOYER' | 'CARD_DECLINE_ORPHANED_EMPLOYEE' | 'RENEWAL_REMINDER' | 'SCHEDULED_REPORT' | 'PUSH_PROVISIONING' | 'EXCESS_CONTRIBUTION' | 'EOY_SHORTAGE_PULL' | 'EOY_SHORTAGE_PUSH' | 'RETURN_UNUSED_FUNDS' | 'CONTRIBUTION_RETURN_PUSH_PULL' | 'COMBINE_HSA' | 'AUTHORIZED_USER' | 'RETURNED_MAIL' | 'BAF_COLLECT_PULL' | 'BAF_COLLECT_PUSH' | 'BAF_RETURN_PULL_PUSH' | 'CARD_DECLINE_LOCKED_CARD_PURSE' | 'RETURNED_CHECK'} notificationType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationServiceServiceApiInterface
     */
    getExternalTemplatesByOrgPathRaw(requestParameters: GetExternalTemplatesByOrgPathRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IExternalTemplateLiteDto>>>;

    /**
     * Get external templates by type, userRole and org path
     */
    getExternalTemplatesByOrgPath(requestParameters: GetExternalTemplatesByOrgPathRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IExternalTemplateLiteDto>>;

    /**
     * 
     * @summary Get SMS preview from Twilio
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationServiceServiceApiInterface
     */
    getSmsTemplatePreviewRaw(requestParameters: GetSmsTemplatePreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Get SMS preview from Twilio
     */
    getSmsTemplatePreview(requestParameters: GetSmsTemplatePreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationServiceServiceApiInterface
     */
    resendCommunicationRaw(requestParameters: ResendCommunicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    resendCommunication(requestParameters: ResendCommunicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Update notifications with read status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationServiceServiceApiInterface
     */
    updateNotificationsWithReadRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Update notifications with read status
     */
    updateNotificationsWithRead(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Update notifications with sent status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationServiceServiceApiInterface
     */
    updateNotificationsWithSentRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Update notifications with sent status
     */
    updateNotificationsWithSent(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class NotificationServiceServiceApi extends runtime.BaseAPI implements NotificationServiceServiceApiInterface {

    /**
     * Dismiss notifications
     */
    async dismissAllAppNotificationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/app-notifications/dismissed`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Dismiss notifications
     */
    async dismissAllAppNotifications(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.dismissAllAppNotificationsRaw(initOverrides);
    }

    /**
     * Dismiss notifications
     */
    async dismissAppNotificationByIdRaw(requestParameters: DismissAppNotificationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['correspondenceId'] == null) {
            throw new runtime.RequiredError(
                'correspondenceId',
                'Required parameter "correspondenceId" was null or undefined when calling dismissAppNotificationById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/app-notifications/dismissed/{correspondence-id}`;
        urlPath = urlPath.replace(`{${"correspondence-id"}}`, encodeURIComponent(String(requestParameters['correspondenceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Dismiss notifications
     */
    async dismissAppNotificationById(requestParameters: DismissAppNotificationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.dismissAppNotificationByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Dismiss a banner for authenticated participant user
     */
    async dismissBannerRaw(requestParameters: DismissBannerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['bannerKey'] == null) {
            throw new runtime.RequiredError(
                'bannerKey',
                'Required parameter "bannerKey" was null or undefined when calling dismissBanner().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/banners/{bannerKey}/dismiss`;
        urlPath = urlPath.replace(`{${"bannerKey"}}`, encodeURIComponent(String(requestParameters['bannerKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Dismiss a banner for authenticated participant user
     */
    async dismissBanner(requestParameters: DismissBannerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.dismissBannerRaw(requestParameters, initOverrides);
    }

    /**
     * Get dismissed notifications
     */
    async getAllDismissedAppNotificationsRaw(requestParameters: GetAllDismissedAppNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDismissedAppNotificationDto>> {
        if (requestParameters['searchDto'] == null) {
            throw new runtime.RequiredError(
                'searchDto',
                'Required parameter "searchDto" was null or undefined when calling getAllDismissedAppNotifications().'
            );
        }

        if (requestParameters['pageable'] == null) {
            throw new runtime.RequiredError(
                'pageable',
                'Required parameter "pageable" was null or undefined when calling getAllDismissedAppNotifications().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['searchDto'] != null) {
            queryParameters['searchDto'] = requestParameters['searchDto'];
        }

        if (requestParameters['pageable'] != null) {
            queryParameters['pageable'] = requestParameters['pageable'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/app-notifications/dismissed`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IDismissedAppNotificationDtoFromJSON(jsonValue));
    }

    /**
     * Get dismissed notifications
     */
    async getAllDismissedAppNotifications(requestParameters: GetAllDismissedAppNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDismissedAppNotificationDto> {
        const response = await this.getAllDismissedAppNotificationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get application notifications for given employee
     */
    async getAppNotificationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IAppNotificationDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/app-notifications`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IAppNotificationDtoFromJSON));
    }

    /**
     * Get application notifications for given employee
     */
    async getAppNotifications(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IAppNotificationDto>> {
        const response = await this.getAppNotificationsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get stream of application notifications for given employee
     */
    async getAppNotificationsStreamRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IAppNotificationDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/app-notifications/stream`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IAppNotificationDtoFromJSON));
    }

    /**
     * Get stream of application notifications for given employee
     */
    async getAppNotificationsStream(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IAppNotificationDto>> {
        const response = await this.getAppNotificationsStreamRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getCommunicationsRaw(requestParameters: GetCommunicationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICommunicationDto>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling getCommunications().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['communicationTypes'] != null) {
            queryParameters['communication_types'] = requestParameters['communicationTypes'];
        }

        if (requestParameters['notificationStatuses'] != null) {
            queryParameters['notification_statuses'] = requestParameters['notificationStatuses'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['end_date'] = requestParameters['endDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/communications`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICommunicationDtoFromJSON(jsonValue));
    }

    /**
     */
    async getCommunications(requestParameters: GetCommunicationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICommunicationDto> {
        const response = await this.getCommunicationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get dismissed banner keys for authenticated participant user
     */
    async getDismissedBannersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/banners/dismissed`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get dismissed banner keys for authenticated participant user
     */
    async getDismissedBanners(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getDismissedBannersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get email preview from SendGrid
     */
    async getEmailTemplatePreviewRaw(requestParameters: GetEmailTemplatePreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getEmailTemplatePreview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/external-templates/{id}/html-preview`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get email preview from SendGrid
     */
    async getEmailTemplatePreview(requestParameters: GetEmailTemplatePreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getEmailTemplatePreviewRaw(requestParameters, initOverrides);
    }

    /**
     * Get email template themes for given organization path
     */
    async getEmailTemplateThemesRaw(requestParameters: GetEmailTemplateThemesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEmailTemplateThemeDto>>> {
        if (requestParameters['organizationPath'] == null) {
            throw new runtime.RequiredError(
                'organizationPath',
                'Required parameter "organizationPath" was null or undefined when calling getEmailTemplateThemes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationPath'] != null) {
            queryParameters['organization_path'] = requestParameters['organizationPath'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/email-template-themes`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IEmailTemplateThemeDtoFromJSON));
    }

    /**
     * Get email template themes for given organization path
     */
    async getEmailTemplateThemes(requestParameters: GetEmailTemplateThemesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEmailTemplateThemeDto>> {
        const response = await this.getEmailTemplateThemesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get external templates by ids
     */
    async getExternalTemplatesByIdsRaw(requestParameters: GetExternalTemplatesByIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageExternalTemplateLiteDto>> {
        if (requestParameters['templateIds'] == null) {
            throw new runtime.RequiredError(
                'templateIds',
                'Required parameter "templateIds" was null or undefined when calling getExternalTemplatesByIds().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['templateIds'] != null) {
            queryParameters['template_ids'] = requestParameters['templateIds'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/external-templates`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageExternalTemplateLiteDtoFromJSON(jsonValue));
    }

    /**
     * Get external templates by ids
     */
    async getExternalTemplatesByIds(requestParameters: GetExternalTemplatesByIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageExternalTemplateLiteDto> {
        const response = await this.getExternalTemplatesByIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get external templates by type, userRole and org path
     */
    async getExternalTemplatesByOrgPathRaw(requestParameters: GetExternalTemplatesByOrgPathRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IExternalTemplateLiteDto>>> {
        if (requestParameters['userType'] == null) {
            throw new runtime.RequiredError(
                'userType',
                'Required parameter "userType" was null or undefined when calling getExternalTemplatesByOrgPath().'
            );
        }

        if (requestParameters['notificationType'] == null) {
            throw new runtime.RequiredError(
                'notificationType',
                'Required parameter "notificationType" was null or undefined when calling getExternalTemplatesByOrgPath().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userType'] != null) {
            queryParameters['user_type'] = requestParameters['userType'];
        }

        if (requestParameters['notificationType'] != null) {
            queryParameters['notification_type'] = requestParameters['notificationType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/external-templates/available`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IExternalTemplateLiteDtoFromJSON));
    }

    /**
     * Get external templates by type, userRole and org path
     */
    async getExternalTemplatesByOrgPath(requestParameters: GetExternalTemplatesByOrgPathRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IExternalTemplateLiteDto>> {
        const response = await this.getExternalTemplatesByOrgPathRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get SMS preview from Twilio
     */
    async getSmsTemplatePreviewRaw(requestParameters: GetSmsTemplatePreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getSmsTemplatePreview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/external-templates/{id}/sms-preview`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get SMS preview from Twilio
     */
    async getSmsTemplatePreview(requestParameters: GetSmsTemplatePreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getSmsTemplatePreviewRaw(requestParameters, initOverrides);
    }

    /**
     */
    async resendCommunicationRaw(requestParameters: ResendCommunicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling resendCommunication().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/communications/{id}/resend`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async resendCommunication(requestParameters: ResendCommunicationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.resendCommunicationRaw(requestParameters, initOverrides);
    }

    /**
     * Update notifications with read status
     */
    async updateNotificationsWithReadRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/app-notifications/read`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update notifications with read status
     */
    async updateNotificationsWithRead(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateNotificationsWithReadRaw(initOverrides);
    }

    /**
     * Update notifications with sent status
     */
    async updateNotificationsWithSentRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/app-notifications/sent`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update notifications with sent status
     */
    async updateNotificationsWithSent(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateNotificationsWithSentRaw(initOverrides);
    }

}

/**
  * @export
  * @enum {string}
  */
export enum GetCommunicationsCommunicationTypesEnum {
    EMAIL = 'EMAIL',
    LETTER = 'LETTER',
    SMS = 'SMS'
}
/**
  * @export
  * @enum {string}
  */
export enum GetCommunicationsNotificationStatusesEnum {
    NOT_SENT = 'NOT_SENT',
    SENT = 'SENT',
    CANCELLED = 'CANCELLED',
    ARCHIVED = 'ARCHIVED',
    READ = 'READ',
    RESENT = 'RESENT',
    SENDING = 'SENDING',
    BOUNCED = 'BOUNCED',
    DELIVERED = 'DELIVERED',
    OPENED = 'OPENED',
    REPORTED_AS_SPAM = 'REPORTED_AS_SPAM',
    UNSUBSCRIBED = 'UNSUBSCRIBED',
    RETURNED = 'RETURNED',
    PENDING_ADDRESS = 'PENDING_ADDRESS'
}
/**
  * @export
  * @enum {string}
  */
export enum GetExternalTemplatesByOrgPathUserTypeEnum {
    PARTICIPANT = 'PARTICIPANT',
    ADMIN = 'ADMIN'
}
/**
  * @export
  * @enum {string}
  */
export enum GetExternalTemplatesByOrgPathNotificationTypeEnum {
    SIGN_UP = 'SIGN_UP',
    FORGOT_PASSWORD = 'FORGOT_PASSWORD',
    WELCOME_ABOARD = 'WELCOME_ABOARD',
    BENEFICIARY_CHANGES = 'BENEFICIARY_CHANGES',
    TRANSFER_OF_ASSETS_UPDATES = 'TRANSFER_OF_ASSETS_UPDATES',
    CARD_STATUS_CHANGE = 'CARD_STATUS_CHANGE',
    PROFILE_UPDATE = 'PROFILE_UPDATE',
    PAYMENT_METHOD_UPDATE = 'PAYMENT_METHOD_UPDATE',
    CLAIM_ACTIVITY_ACTION = 'CLAIM_ACTIVITY_ACTION',
    CARD_TRANSACTION_ALERT = 'CARD_TRANSACTION_ALERT',
    PASSWORD_CHANGED = 'PASSWORD_CHANGED',
    CLAIM_ACTIVITY_NO_ACTION = 'CLAIM_ACTIVITY_NO_ACTION',
    CONTRIBUTION_INVOICE_READY = 'CONTRIBUTION_INVOICE_READY',
    REPLENISHMENT_INVOICE_READY = 'REPLENISHMENT_INVOICE_READY',
    CARD_ACTIVATION_REMINDER = 'CARD_ACTIVATION_REMINDER',
    TRIGGER_MET = 'TRIGGER_MET',
    ORPHAN = 'ORPHAN',
    CLOSED_ACCOUNT = 'CLOSED_ACCOUNT',
    ACH_REJECTED = 'ACH_REJECTED',
    PRE_FUND = 'PRE_FUND',
    INDIVIDUAL_CONTRIBUTION = 'INDIVIDUAL_CONTRIBUTION',
    FILE_PROCESSED_SUCCESSFULLY = 'FILE_PROCESSED_SUCCESSFULLY',
    STATEMENT_GENERATED = 'STATEMENT_GENERATED',
    CIP_FAILED = 'CIP_FAILED',
    INDIVIDUAL_CONTRIBUTION_REMINDER = 'INDIVIDUAL_CONTRIBUTION_REMINDER',
    CARD_DECLINE_ACTIVATION_NEEDED = 'CARD_DECLINE_ACTIVATION_NEEDED',
    OUTSTANDING_CHECK_REMINDER = 'OUTSTANDING_CHECK_REMINDER',
    CARD_DECLINE_LOST_STOLEN = 'CARD_DECLINE_LOST_STOLEN',
    CARD_DECLINE_LOCKED_FROZEN = 'CARD_DECLINE_LOCKED_FROZEN',
    CHECK_VOID = 'CHECK_VOID',
    AUTOMATIC_INVESTMENTS = 'AUTOMATIC_INVESTMENTS',
    CARD_DECLINE_WALMART = 'CARD_DECLINE_WALMART',
    CARD_DECLINE_NON_HEALTHCARE = 'CARD_DECLINE_NON_HEALTHCARE',
    REIMBURSEMENT_FAILED = 'REIMBURSEMENT_FAILED',
    CARD_DECLINE_CVS_NOT_ALLOWED = 'CARD_DECLINE_CVS_NOT_ALLOWED',
    CARD_DECLINE_NOT_ENOUGH_BALANCE = 'CARD_DECLINE_NOT_ENOUGH_BALANCE',
    CARD_DECLINE_PLAN_NOT_STARTED = 'CARD_DECLINE_PLAN_NOT_STARTED',
    CHECK_EXPIRED = 'CHECK_EXPIRED',
    CARD_DECLINE_NO_AVAILABLE_BALANCE = 'CARD_DECLINE_NO_AVAILABLE_BALANCE',
    CARD_DECLINE_GENERIC = 'CARD_DECLINE_GENERIC',
    INDIVIDUAL_CONTRIBUTION_FAILED = 'INDIVIDUAL_CONTRIBUTION_FAILED',
    CARD_DECLINE_PAST_PLAN_END_DATE = 'CARD_DECLINE_PAST_PLAN_END_DATE',
    ISO_NEEDS_HELP = 'ISO_NEEDS_HELP',
    CARD_DECLINE_PIN_INVALID = 'CARD_DECLINE_PIN_INVALID',
    ISO_ORG_LOCKED = 'ISO_ORG_LOCKED',
    ISO_OVERLIMIT = 'ISO_OVERLIMIT',
    PHONE_VERIFICATION = 'PHONE_VERIFICATION',
    MFA_SMS = 'MFA_SMS',
    MFA_EMAIL = 'MFA_EMAIL',
    CARD_DECLINE_NOT_ALLOWED_SERVICE_FOR_PLAN = 'CARD_DECLINE_NOT_ALLOWED_SERVICE_FOR_PLAN',
    EMAIL_VERIFICATION = 'EMAIL_VERIFICATION',
    FORGOT_USERNAME = 'FORGOT_USERNAME',
    CARD_DECLINE_PEND_CONTRIBUTIONS = 'CARD_DECLINE_PEND_CONTRIBUTIONS',
    CARD_DECLINE_PEND_CONTRIBUTIONS_AND_CIP = 'CARD_DECLINE_PEND_CONTRIBUTIONS_AND_CIP',
    COMPLETE_SETUP = 'COMPLETE_SETUP',
    EMPLOYEE_ELECTION_NEEDED = 'EMPLOYEE_ELECTION_NEEDED',
    END_PLAN_YEAR_INITIAL = 'END_PLAN_YEAR_INITIAL',
    LOCKBOX_INBOUND_TOA_PROCESSED = 'LOCKBOX_INBOUND_TOA_PROCESSED',
    CONTACT_INFO_UPDATED = 'CONTACT_INFO_UPDATED',
    SCHEDULED_CONTRIBUTION = 'SCHEDULED_CONTRIBUTION',
    END_PLAN_YEAR_REMINDER = 'END_PLAN_YEAR_REMINDER',
    CLAIM_OFFSET = 'CLAIM_OFFSET',
    LOCKBOX_OUTBOUND_TOA_PENDING_INVESTMENTS = 'LOCKBOX_OUTBOUND_TOA_PENDING_INVESTMENTS',
    LOCKBOX_OUTBOUND_TOA_PROCESSED = 'LOCKBOX_OUTBOUND_TOA_PROCESSED',
    NEW_BANK_ACCOUNT_ADDED = 'NEW_BANK_ACCOUNT_ADDED',
    SMS_CONTACT_VERIFICATION = 'SMS_CONTACT_VERIFICATION',
    EMAIL_CONTACT_VERIFICATION = 'EMAIL_CONTACT_VERIFICATION',
    BANK_ACCOUNT_VERIFICATION_STATUS_CHANGE = 'BANK_ACCOUNT_VERIFICATION_STATUS_CHANGE',
    PERSON_ACCOUNTS_LINKED = 'PERSON_ACCOUNTS_LINKED',
    TAX_FORMS = 'TAX_FORMS',
    PRE_FUND_PUSH = 'PRE_FUND_PUSH',
    CARD_DECLINE_DATA_ENTERED_INCORRECTLY = 'CARD_DECLINE_DATA_ENTERED_INCORRECTLY',
    DUPLICATE_FILE_FOUND = 'DUPLICATE_FILE_FOUND',
    INTERNAL_FEEDBACK = 'INTERNAL_FEEDBACK',
    BENEFICIARY_UPDATE = 'BENEFICIARY_UPDATE',
    RENEWAL_INITIAL = 'RENEWAL_INITIAL',
    CIP_FAILED_CLOSED_ACCOUNT = 'CIP_FAILED_CLOSED_ACCOUNT',
    CARD_DECLINE_TEMPORARY_BLOCKED_MERCHANT = 'CARD_DECLINE_TEMPORARY_BLOCKED_MERCHANT',
    CARD_DECLINE_PERMANENTLY_BLOCKED_MERCHANT = 'CARD_DECLINE_PERMANENTLY_BLOCKED_MERCHANT',
    RENEWAL_REQUEST = 'RENEWAL_REQUEST',
    CARD_DECLINE_TERMINATED_EMPLOYEE = 'CARD_DECLINE_TERMINATED_EMPLOYEE',
    CARD_DECLINE_TERMINATED_EMPLOYER = 'CARD_DECLINE_TERMINATED_EMPLOYER',
    CARD_DECLINE_ORPHANED_EMPLOYEE = 'CARD_DECLINE_ORPHANED_EMPLOYEE',
    RENEWAL_REMINDER = 'RENEWAL_REMINDER',
    SCHEDULED_REPORT = 'SCHEDULED_REPORT',
    PUSH_PROVISIONING = 'PUSH_PROVISIONING',
    EXCESS_CONTRIBUTION = 'EXCESS_CONTRIBUTION',
    EOY_SHORTAGE_PULL = 'EOY_SHORTAGE_PULL',
    EOY_SHORTAGE_PUSH = 'EOY_SHORTAGE_PUSH',
    RETURN_UNUSED_FUNDS = 'RETURN_UNUSED_FUNDS',
    CONTRIBUTION_RETURN_PUSH_PULL = 'CONTRIBUTION_RETURN_PUSH_PULL',
    COMBINE_HSA = 'COMBINE_HSA',
    AUTHORIZED_USER = 'AUTHORIZED_USER',
    RETURNED_MAIL = 'RETURNED_MAIL',
    BAF_COLLECT_PULL = 'BAF_COLLECT_PULL',
    BAF_COLLECT_PUSH = 'BAF_COLLECT_PUSH',
    BAF_RETURN_PULL_PUSH = 'BAF_RETURN_PULL_PUSH',
    CARD_DECLINE_LOCKED_CARD_PURSE = 'CARD_DECLINE_LOCKED_CARD_PURSE',
    RETURNED_CHECK = 'RETURNED_CHECK'
}
